import { createApp } from 'vue'
import App from './App.vue'

import router from './router'
import 'vant/lib/index.css';
import 'amfe-flexible'
import Header from './components/Header.vue'
import TabBar from './components/TabBar.vue'

import { Progress, Circle, Tabbar, TabbarItem, Popup, NavBar, Tab, Tabs, Popover } from 'vant'
const app = createApp(App)
app.use(router)
app.component('Header', Header)
app.component('TabBar', TabBar)
app.use(Progress).use(Circle).use(Tabbar).use(TabbarItem).use(Popup).use(NavBar).use(Tab).use(Tabs)
.use(Popover)
app.mount('#app')
